import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju62emas2y: FaireProductEntity = {
  token: "p_ju62emas2y",
  type: "product",
  name: "New | Teak Wood Heart Shaped Bowl",
  brandName: "Balizen Direct from Bali",
  imageUrl:
    "https://cdn.faire.com/fastly/6712940d6a7befa8a02a6f3a20675c79f6981aa9deb348ca4d710d6b1f31ea57.png",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f5fefd2471b023a6ec0b12b30dd7f182a2cf621175abb40218e0990cc0824953.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
